<template>
  <div class="content">
    <p>订单审核</p>
    <div class="actions-bar">
      <el-input placeholder="请输入订单ID" clearable v-model="id">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input placeholder="userId" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select v-model="status" placeholder="请选择审核状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="已取消" value="-1"></el-option>
        <!-- <el-option label="待付款" value="1"></el-option> -->
        <el-option label="待付款" value="2"></el-option>
        <el-option label="已付款" value="3"></el-option>
        <el-option label="完成" value="4"></el-option>
        <el-option label="待审核" value="5"></el-option>
      </el-select>
      <el-button type="primary" class="searchBtn" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="OrderList" style="width: 100%">
      <el-table-column prop="id" label="订单ID" > </el-table-column>
      <el-table-column prop="advertisingId" label="广告ID"> </el-table-column>
      <el-table-column prop="merchantId" label="商家ID"> </el-table-column>
      <el-table-column prop="alleged" label="申述状态">
        <template slot-scope="scope">
          <span v-if="scope.row.alleged">申述中</span>
          <span v-else>未申述</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}{{ scope.row.coinType }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="currencyCoin" label="法币币种">
        <template slot-scope="scope">
          <span>{{ scope.row.currencyCoinAmount }}{{ scope.row.currencyCoin }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="" label="方向">
        <template slot-scope="scope">
          <span v-if="scope.row.direction == 'B'">购买</span>
          <span v-else>出售</span>
        </template>
      </el-table-column>

      <el-table-column prop="buyerId" label="买家ID">
        <template slot-scope="scope">
          <a class="account-link" @click="getUserDetail(scope.row.buyerId)">{{ scope.row.buyerId }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="sellerId" label="卖家ID">
        <template slot-scope="scope">
          <a class="account-link" @click="getUserDetail(scope.row.sellerId)">{{ scope.row.sellerId }}</a>
        </template>
      </el-table-column>

      <el-table-column label="卖家标签">
        <template slot-scope="scope">
          <span style="color: red">{{scope.row.sellerTag}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="takerId" label="takerId"> </el-table-column>
      <el-table-column prop="" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == -1">取消</span>
          <span v-else-if="scope.row.status == 2">待付款</span>
          <span v-else-if="scope.row.status == 3">已付款</span>
          <span v-else-if="scope.row.status == 4">完成</span>
          <span v-else-if="scope.row.status == 5">待审核</span>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="allDepositEnsured" label="充值确认"  :filters="[{text: '都已确认', value: true}, {text: '有未确认或异常', value: false}]" :filter-method="filterHandler">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__allDepositEnsured.color">{{scope.row.__allDepositEnsured.text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" v-if="scope.row.status == 5" size="small">审核</el-button>
          <el-button @click="handleClick(scope.row)" type="text" v-else disabled size="small">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="OrderListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-dialog title="审核" :visible.sync="auditlVisible" width="40%" center>
      {{ auditForm }}
      审核ID:{{ auditForm.id }}
      <el-form :model="auditForm" status-icon ref="auditForm" label-width="100px" class="applicationForm">
        <p class="fromCaptionTitle">审核理由</p>
        <el-form-item label="理由" prop="nickName">
          <el-input type="textarea" v-model="auditForm.reason"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">基本信息</p>

        <el-form-item label="状态">
          <el-select v-model="auditForm.isPassed" placeholder="请选择审核状态">
            <el-option label="通过" value="true"></el-option>
            <el-option label="不通过（取消订单）" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditlVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditPayeeBtn">确 定</el-button>
      </span>
    </el-dialog>

    <balance :show="showBalance" @close="showBalance = false"></balance>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import balance from "../../../balance";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      page: 1,
      size: 11,
      userId: "",
      status: "5",
      id: "",
      // MerchantRecordList:{}
      auditlVisible: false,
      auditForm: {
        id: "",
        description: "",
        isPassed: ""
      },
      showBalance: false
    };
  },
  computed: {
    ...mapState("otc", ["OrderListTotal", "OrderList"])
  },
  components: { balance },
  methods: {
    ...mapActions("otc", ["getOrderList"]),
    ...mapActions("withdrawalAudit", ["getUserWallet"]),
    getUserDetail(uid) {
      this.getUserWallet({ userId: uid });
      this.showBalance = true;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    pageChange(e) {
      console.log(e);
      this.page = e;
      this.handleSearch();
    },
    sizeChange(e) {
      this.page = e;
      this.handleSearch();
    },

    //shousuo
    handleSearch() {
      let that = this;

      if (that.id) {
        that.status = "";
      }

      this.getOrderList({
        id: that.id,
        status: that.status,
        userId: that.userId,
        size: that.size,
        page: that.page
      });
    },

    handleClick(row) {
      if (row.sellerTag === null) {
        this.auditlVisible = true;
        this.auditForm.id = row.id;
      }else {
        this.$confirm("该用户为：" + row.sellerTag + "，是否继续?", "提示", {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        }).then(() => {
          this.auditlVisible = true;
          this.auditForm.id = row.id;
        })
                .catch(() => {
                  this.$message.info("已取消执行")
                })
      }

    },

    //取消订单
    cancelOrder(row, toFrom) {
      let that = this;
      let data = {
        id: row.id
      };
      api.allege(data, toFrom).then(res => {
        console.log("shenghe", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },

    auditPayeeBtn() {
      let that = this;
      this.auditForm.id = this.auditForm.id.toString();
      if (this.auditForm.isPassed == "true") {
        this.auditForm.description = "";
      } else {
        if (!this.auditForm.reason) {
          const h = that.$createElement;
          that.$notify({
            title: "",
            message: h("i", { style: "color: teal" }, "请填写理由")
            // duration: 0
          });
          return false;
        }
        this.auditForm.description = this.auditForm.reason.toString();
      }

      let data = this.auditForm;
      api.orderApprove(data).then(res => {
        console.log("shenghe", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },

  mounted() {
    this.handleSearch();
  }
};
</script>

<style lang="less" scoped>
.content {
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
    .searchBtn {
      margin-left: 15px;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
.el-message-box {
  background: red !important;
}
</style>
